import _objectSpread from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _slicedToArray from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import Joi from 'joi';
var userEmail = Joi.string().email({
  tlds: {
    allow: false
  }
}).allow(null);
var magicOptions = Joi.object({
  apiKey: Joi.string().required(),
  userEmail: userEmail
});

var validate = function validate(validator, data) {
  var result = validator.validate(data);
  return result.error ? result : null;
};

var validateMagicInitOptions = function validateMagicInitOptions(data) {
  return validate(magicOptions, data);
};

var validateUserEmail = function validateUserEmail(email) {
  return validate(userEmail, email);
};

function magic(options) {
  if (options) {
    var error = validateMagicInitOptions(options);

    if (error) {
      throw error;
    }
  }

  var apiKey = options.apiKey,
      userEmail = options.userEmail;
  var walletName = 'Magic Wallet';
  return function () {
    return {
      label: walletName,
      getIcon: function () {
        var _getIcon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return import('./icon-87babf0a.js');

                case 2:
                  return _context.abrupt("return", _context.sent.default);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function getIcon() {
          return _getIcon.apply(this, arguments);
        }

        return getIcon;
      }(),
      getInterface: function () {
        var _getInterface = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(_ref) {
          var EventEmitter, BigNumber, chains, _yield$import, Magic, RPCErrorCode, loginModal, brandingHTML, _yield$import2, createEIP1193Provider, ProviderRpcErrorCode, ProviderRpcError, emitter, currentChain, customNodeOptions, magicInstance, loggedIn, loginWithEmail, handleLogin, magicProvider, provider, activeAddress, patchProvider;

          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  patchProvider = function _patchProvider() {
                    var patchedProvider = createEIP1193Provider(magicProvider, {
                      eth_requestAccounts: function () {
                        var _eth_requestAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref4) {
                          var baseRequest, accounts, code;
                          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  baseRequest = _ref4.baseRequest;
                                  _context4.prev = 1;

                                  if (!userEmail) {
                                    _context4.next = 6;
                                    break;
                                  }

                                  _context4.next = 5;
                                  return loginWithEmail(userEmail);

                                case 5:
                                  loggedIn = _context4.sent;

                                case 6:
                                  if (loggedIn) {
                                    _context4.next = 9;
                                    break;
                                  }

                                  _context4.next = 9;
                                  return handleLogin();

                                case 9:
                                  _context4.next = 11;
                                  return baseRequest({
                                    method: 'eth_accounts'
                                  });

                                case 11:
                                  accounts = _context4.sent;
                                  activeAddress = accounts[0];
                                  return _context4.abrupt("return", accounts);

                                case 16:
                                  _context4.prev = 16;
                                  _context4.t0 = _context4["catch"](1);
                                  code = _context4.t0.code;

                                  if (!(code === RPCErrorCode.InternalError)) {
                                    _context4.next = 21;
                                    break;
                                  }

                                  throw new ProviderRpcError({
                                    code: ProviderRpcErrorCode.ACCOUNT_ACCESS_REJECTED,
                                    message: 'Account access rejected'
                                  });

                                case 21:
                                  return _context4.abrupt("return", []);

                                case 22:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _callee4, null, [[1, 16]]);
                        }));

                        function eth_requestAccounts(_x3) {
                          return _eth_requestAccounts.apply(this, arguments);
                        }

                        return eth_requestAccounts;
                      }(),
                      eth_selectAccounts: null,
                      eth_getBalance: function () {
                        var _eth_getBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref5) {
                          var baseRequest, balance;
                          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                            while (1) {
                              switch (_context5.prev = _context5.next) {
                                case 0:
                                  baseRequest = _ref5.baseRequest;
                                  _context5.next = 3;
                                  return baseRequest({
                                    method: 'eth_getBalance',
                                    params: [activeAddress, 'latest']
                                  });

                                case 3:
                                  balance = _context5.sent;
                                  return _context5.abrupt("return", balance ? BigNumber.from(balance).mul('1000000000000000000').toString() : '0');

                                case 5:
                                case "end":
                                  return _context5.stop();
                              }
                            }
                          }, _callee5);
                        }));

                        function eth_getBalance(_x4) {
                          return _eth_getBalance.apply(this, arguments);
                        }

                        return eth_getBalance;
                      }(),
                      wallet_switchEthereumChain: function () {
                        var _wallet_switchEthereumChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(_ref6) {
                          var params, chain;
                          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                            while (1) {
                              switch (_context6.prev = _context6.next) {
                                case 0:
                                  params = _ref6.params;
                                  chain = chains.find(function (_ref7) {
                                    var id = _ref7.id;
                                    return id === params[0].chainId;
                                  });

                                  if (chain) {
                                    _context6.next = 4;
                                    break;
                                  }

                                  throw new Error('Chain must be set before switching');

                                case 4:
                                  currentChain = chain; // re-instantiate instance with new network

                                  customNodeOptions = {
                                    chainId: parseInt(currentChain.id),
                                    rpcUrl: currentChain.rpcUrl
                                  };
                                  magicInstance = new Magic(apiKey, {
                                    network: customNodeOptions
                                  });
                                  magicProvider = magicInstance.rpcProvider;
                                  emitter.emit('chainChanged', currentChain.id);
                                  patchProvider();
                                  return _context6.abrupt("return", null);

                                case 11:
                                case "end":
                                  return _context6.stop();
                              }
                            }
                          }, _callee6);
                        }));

                        function wallet_switchEthereumChain(_x5) {
                          return _wallet_switchEthereumChain.apply(this, arguments);
                        }

                        return wallet_switchEthereumChain;
                      }(),
                      eth_sign: function () {
                        var _eth_sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_ref8) {
                          var params, receipt;
                          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                            while (1) {
                              switch (_context7.prev = _context7.next) {
                                case 0:
                                  params = _ref8.params;
                                  _context7.next = 3;
                                  return magicProvider.send('eth_sign', params);

                                case 3:
                                  receipt = _context7.sent;
                                  return _context7.abrupt("return", receipt && receipt.hasOwnProperty('tx') && receipt.tx.hasOwnProperty('hash') ? receipt.tx.hash : '');

                                case 5:
                                case "end":
                                  return _context7.stop();
                              }
                            }
                          }, _callee7);
                        }));

                        function eth_sign(_x6) {
                          return _eth_sign.apply(this, arguments);
                        }

                        return eth_sign;
                      }(),
                      eth_signTypedData: function () {
                        var _eth_signTypedData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(_ref9) {
                          var params, receipt;
                          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                            while (1) {
                              switch (_context8.prev = _context8.next) {
                                case 0:
                                  params = _ref9.params;
                                  _context8.next = 3;
                                  return magicProvider.send('eth_sign', params);

                                case 3:
                                  receipt = _context8.sent;
                                  return _context8.abrupt("return", receipt && receipt.hasOwnProperty('tx') && receipt.tx.hasOwnProperty('hash') ? receipt.tx.hash : '');

                                case 5:
                                case "end":
                                  return _context8.stop();
                              }
                            }
                          }, _callee8);
                        }));

                        function eth_signTypedData(_x7) {
                          return _eth_signTypedData.apply(this, arguments);
                        }

                        return eth_signTypedData;
                      }(),
                      eth_chainId: function () {
                        var _eth_chainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                            while (1) {
                              switch (_context9.prev = _context9.next) {
                                case 0:
                                  return _context9.abrupt("return", currentChain && currentChain.hasOwnProperty('id') ? currentChain.id : '0x1');

                                case 1:
                                case "end":
                                  return _context9.stop();
                              }
                            }
                          }, _callee9);
                        }));

                        function eth_chainId() {
                          return _eth_chainId.apply(this, arguments);
                        }

                        return eth_chainId;
                      }(),
                      eth_signTransaction: function () {
                        var _eth_signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(_ref10) {
                          var _ref10$params, transactionObject, destination, receipt;

                          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                            while (1) {
                              switch (_context10.prev = _context10.next) {
                                case 0:
                                  _ref10$params = _slicedToArray(_ref10.params, 1), transactionObject = _ref10$params[0];

                                  if (transactionObject.hasOwnProperty('to')) {
                                    destination = transactionObject.to;
                                  }

                                  _context10.next = 4;
                                  return magicProvider.send('eth_signTransaction', [_objectSpread(_objectSpread({}, transactionObject), {}, {
                                    nonce: transactionObject.hasOwnProperty('nonce') && typeof transactionObject.nonce === 'number' ? parseInt(transactionObject.nonce) : '',
                                    from: activeAddress,
                                    to: destination
                                  })]);

                                case 4:
                                  receipt = _context10.sent;
                                  return _context10.abrupt("return", receipt && receipt.hasOwnProperty('tx') && receipt.tx.hasOwnProperty('hash') ? receipt.tx.hash : '');

                                case 6:
                                case "end":
                                  return _context10.stop();
                              }
                            }
                          }, _callee10);
                        }));

                        function eth_signTransaction(_x8) {
                          return _eth_signTransaction.apply(this, arguments);
                        }

                        return eth_signTransaction;
                      }()
                    });

                    if (!provider) {
                      patchedProvider.on = emitter.on.bind(emitter);

                      patchedProvider.disconnect = function () {
                        return magicInstance.user.logout();
                      };

                      return patchedProvider;
                    } else {
                      provider.request = patchedProvider.request.bind(patchedProvider); // @ts-ignore - bind old methods for backwards compat

                      provider.send = patchedProvider.send.bind(patchedProvider); // @ts-ignore - bind old methods for backwards compat

                      provider.sendAsync = patchedProvider.sendAsync.bind(patchedProvider);
                      return provider;
                    }
                  };

                  EventEmitter = _ref.EventEmitter, BigNumber = _ref.BigNumber, chains = _ref.chains;
                  _context11.next = 4;
                  return import('magic-sdk');

                case 4:
                  _yield$import = _context11.sent;
                  Magic = _yield$import.Magic;
                  RPCErrorCode = _yield$import.RPCErrorCode;
                  _context11.next = 9;
                  return import('./login-modal-b5b11652.js');

                case 9:
                  loginModal = _context11.sent.default;
                  _context11.next = 12;
                  return import('./branding-111ba967.js');

                case 12:
                  brandingHTML = _context11.sent.default;
                  _context11.next = 15;
                  return import('@web3-onboard/common');

                case 15:
                  _yield$import2 = _context11.sent;
                  createEIP1193Provider = _yield$import2.createEIP1193Provider;
                  ProviderRpcErrorCode = _yield$import2.ProviderRpcErrorCode;
                  ProviderRpcError = _yield$import2.ProviderRpcError;
                  emitter = new EventEmitter();

                  if (chains.length) {
                    _context11.next = 22;
                    break;
                  }

                  throw new Error('At least one Chain must be passed to onboard in order to connect');

                case 22:
                  currentChain = chains[0];
                  customNodeOptions = {
                    chainId: parseInt(currentChain.id),
                    rpcUrl: currentChain.rpcUrl
                  };
                  magicInstance = new Magic(apiKey, {
                    network: customNodeOptions
                  });

                  loginWithEmail = /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(emailAddress) {
                      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.prev = 0;
                              _context2.next = 3;
                              return magicInstance.auth.loginWithMagicLink({
                                email: emailAddress
                              });

                            case 3:
                              _context2.next = 5;
                              return magicInstance.user.isLoggedIn();

                            case 5:
                              return _context2.abrupt("return", _context2.sent);

                            case 8:
                              _context2.prev = 8;
                              _context2.t0 = _context2["catch"](0);
                              throw new Error("An error occurred while connecting your Magic wallet, please try again: ".concat(_context2.t0));

                            case 11:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2, null, [[0, 8]]);
                    }));

                    return function loginWithEmail(_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }();

                  handleLogin = /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return loginModal({
                                walletName: walletName,
                                brandingHTMLString: brandingHTML,
                                emailLoginFunction: loginWithEmail
                              });

                            case 2:
                              loggedIn = _context3.sent;

                            case 3:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));

                    return function handleLogin() {
                      return _ref3.apply(this, arguments);
                    };
                  }();

                  magicProvider = magicInstance.rpcProvider;
                  provider = patchProvider();
                  return _context11.abrupt("return", {
                    provider: provider,
                    instance: magicInstance
                  });

                case 30:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));

        function getInterface(_x) {
          return _getInterface.apply(this, arguments);
        }

        return getInterface;
      }()
    };
  };
}

export { magic as m, validateUserEmail as v };